import Vue, { CreateElement, VNode } from 'vue'
import DonationSelector from '@/components/donation/DonationSelector.vue'

export const donationChoose = (fn: any, villageId: any) => {
  let selector = new (Vue.extend({
    render (createElement: CreateElement): VNode {
      return createElement(DonationSelector, {
        props: {
          callback: fn,
          villageId: villageId
        }
      })
    }
  }))()
  let container = document.createElement('div')
  document.body.appendChild(container)
  selector.$mount(container)
}
